/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'
import ForwardIcon from '@mui/icons-material/Forward'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, tinderProfileBackgroundColor, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileTextColor, tinderProfilePromptTextColor, tinderProfileItemDividerOpacity, tinderProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileImageWidth, tinderProfileImageIndicatorWidth, tinderLeadImageHeight, tinderImageHeight, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'

export const viewTinderImages = (viewFeedbackTrue, giveFeedbackTrue, imageIndex, datingProfile, viewTinderImageIndex, setViewTinderImageIndex, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, width) => {
  // console.log('imageIndex ->', imageIndex)
  // console.log('datingProfile.media ->', datingProfile.media[imageIndex])
  // console.log('viewFeedbackTrue ->', viewFeedbackTrue)
  // console.log('giveFeedbackTrue ->', giveFeedbackTrue)

  const handleShowSubcaption = () => {
    // console.log('handleShowSubcaption runs index ->', imageIndex)
    setShowSubcaption({ ...showSubcaption, [`mediaItem${imageIndex + 1}`]: !showSubcaption[`mediaItem${imageIndex + 1}`] })
  }

  const arrowBackgroundColor = () => {
    return (
      (
        giveFeedbackTrue
        &&
        (
          datingProfile.mediaFeedback.filter(feedbackItem => feedbackItem.verdict.length === 0 || (!datingProfile.isFriendReview && feedbackItem.feedback.length === 0)).length > 0
        )
      )
        ?
        'mistyrose'
        :
        giveFeedbackTrue
          ?
          'lightblue'
          :
          'white'
    )
  }

  return (
    <Box
      sx={{
        mt: 1,
        boxShadow: tinderProfileItemBoxShadow, 
        borderRadius: '0px',
      }}
    >
      
      {/* Image/Video */}
      <Box 
        component={datingProfile.media[imageIndex].mediaType === 'video' ? 'video' : ''}
        onLoadStart={() => setMediaIsLoading({ ...mediaIsLoading, [`mediaItem${imageIndex + 1}`]: true })}
        onLoadedData={() => setMediaIsLoading({ ...mediaIsLoading, [`mediaItem${imageIndex + 1}`]: false })}
        src={datingProfile.media[imageIndex].mediaType === 'video' ? datingProfile.media[imageIndex].mediaItemURL : null} 
        autoPlay={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
        playsInline={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
        loop={datingProfile.media[imageIndex].mediaType === 'video' ? true : false}
        muted={datingProfile.media[imageIndex].mediaType === 'video' ? true : true}
        sx={{ 
          // mt: 1,
          width: tinderProfileImageWidth(width),
          height: tinderImageHeight(width),
          backgroundImage: `url(${datingProfile.media[imageIndex].mediaItemURL})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          // boxShadow: 3, 
          borderRadius: '0px', 
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', 
        }}
      >
        {/* Image Indicators */}
        {datingProfile.media.length > 1 &&
          <Box
            sx={{
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', 
              flexWrap: 'nowrap',
            }}  
          >
            {Array.from({ length: datingProfile.media.length },(v,k)=> k ).map(itemIndex => (
              <Box
                key={itemIndex}
                sx={{
                  mt: 1,
                  mr: (itemIndex === datingProfile.media.length - 1) ? 0 : '4px',
                  width: tinderProfileImageIndicatorWidth(width, datingProfile.media.length),
                  height: '5px',
                  backgroundColor: itemIndex === viewTinderImageIndex ? tinderProfileTextColor : tinderProfileBackgroundColor,
                  // borderColor: 'white',
                  border: .75,
                  borderRadius: 1,
                  borderColor: itemIndex === viewTinderImageIndex ? tinderProfileBackgroundColor : tinderProfileTextColor,
                  // boxShadow: tinderProfileItemBoxShadow,
                }}
              >
                {/* {console.log('itemIndex ->', itemIndex)}
                {console.log('indicator width ->', tinderProfileImageIndicatorWidth(width, datingProfile.media.length))} */}
              </Box>
            ))}
          </Box>
        }

        {/* Left/Right Touch Boxes */}
        <Box
          sx={{
            mt: 1,
            width: '100%',
            height: tinderImageHeight(width) - 50,
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
          }}
        >
          {/* Back */}
          <Box
            onClick={(e) => (viewTinderImageIndex > 0) && setViewTinderImageIndex(viewTinderImageIndex - 1)}
            disabled={viewTinderImageIndex === 0}
            sx={{
              // backgroundColor: 'pink',
              width: '33%',
              height: tinderImageHeight(width) - 50,
              cursor: viewTinderImageIndex === 0 ? 'default' : 'pointer',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
            }}
          >
            {viewTinderImageIndex !== 0 &&
              <Box
                sx={{
                  m: 1,
                  width: '35px',
                  height: '35px',
                  // border: 1,
                  // borderColor: 'black',
                  borderRadius: '50%',
                  boxShadow: 3,
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <ArrowBackIcon 
                  // size={'lg'}
                  sx={{
                    m: 1,
                    color: 'black',
                    backgroundColor: arrowBackgroundColor(),
                    width: '35px',
                    height: '35px',
                    // border: 1,
                    // borderColor: 'black',
                    borderRadius: '50%',
                    // boxShadow: 3,
                    opacity: giveFeedbackTrue && arrowBackgroundColor() === 'mistyrose' ? 1 : giveFeedbackTrue ? .9 : .5,
                  }}
                />
              </Box>
            }
          </Box>

          {/* Loading */}
          {mediaIsLoading[`mediaItem${imageIndex + 1}`] 
            &&
            <Box
              sx={{
                width: '30%',
                height: tinderImageHeight(width),
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              Media is Loading...
            </Box>
          }

          {/* Forward */}
          <Box
            onClick={(e) => (viewTinderImageIndex < datingProfile.media.length - 1) && setViewTinderImageIndex(viewTinderImageIndex + 1)}
            disabled={viewTinderImageIndex >= datingProfile.media.length - 1}
            sx={{
              // backgroundColor: 'pink',
              width: '33%',
              height: tinderImageHeight(width) - 50,
              cursor: viewTinderImageIndex === datingProfile.media.length - 1 ? 'default' : 'pointer',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end',
            }}
          >
            {viewTinderImageIndex !== datingProfile.media.length - 1 &&
              <Box
                sx={{
                  m: 1,
                  width: '35px',
                  height: '35px',
                  // border: 1,
                  // borderColor: 'black',
                  borderRadius: '50%',
                  boxShadow: 3,
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <ArrowForwardIcon 
                  // size={'lg'}
                  sx={{
                    // m: 1,
                    color: 'black',
                    // backgroundColor: viewTinderImageIndex === 0 ? 'yellow' : 'white',
                    backgroundColor: arrowBackgroundColor(),
                    width: '35px',
                    height: '35px',
                    // border: 1,
                    // borderColor: 'black',
                    borderRadius: '50%',
                    // boxShadow: 0,
                    opacity: giveFeedbackTrue && arrowBackgroundColor() === 'mistyrose' ? 1 : giveFeedbackTrue || viewTinderImageIndex === 0 ? .9 : .5,
                  }}
                />
              </Box>
            }
          </Box>

        </Box>
      </Box>

      {/* Image indicators for videos */}
      {datingProfile.media[imageIndex].mediaType === 'video' &&
        datingProfile.media.length > 1 &&
          <Box
            sx={{
              width: '100%',
              position: 'relative', top: -(tinderImageHeight(width)),
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', 
              flexWrap: 'nowrap',
            }}  
          >
            {Array.from({ length: datingProfile.media.length },(v,k)=> k ).map(itemIndex => (
              <Box
                key={itemIndex}
                sx={{
                  mt: 1,
                  mr: (itemIndex === datingProfile.media.length - 1) ? 0 : '4px',
                  width: tinderProfileImageIndicatorWidth(width, datingProfile.media.length),
                  height: '5px',
                  backgroundColor: itemIndex === viewTinderImageIndex ? tinderProfileTextColor : tinderProfileBackgroundColor,
                  // borderColor: 'white',
                  border: .75,
                  borderRadius: 1,
                  borderColor: itemIndex === viewTinderImageIndex ? tinderProfileBackgroundColor : tinderProfileTextColor,
                  // boxShadow: tinderProfileItemBoxShadow,
                }}
              >
                {/* {console.log('itemIndex ->', itemIndex)}
                {console.log('indicator width ->', tinderProfileImageIndicatorWidth(width, datingProfile.media.length))} */}
              </Box>
            ))}
          </Box>
      }

      {/* Arrows for Videos */}
      {datingProfile.media[imageIndex].mediaType === 'video' &&
        <Box
          sx={{
            mt: 1,
            width: '100%',
            height: tinderImageHeight(width) - 50,
            position: 'relative', top: -(tinderImageHeight(width)),
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
          }}
        >
          {/* Back */}
          <Box
            onClick={(e) => (viewTinderImageIndex > 0) && setViewTinderImageIndex(viewTinderImageIndex - 1)}
            disabled={viewTinderImageIndex === 0}
            sx={{
              // backgroundColor: 'pink',
              width: '33%',
              height: tinderImageHeight(width) - 50,
              cursor: viewTinderImageIndex === 0 ? 'default' : 'pointer',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
            }}
          >
            {viewTinderImageIndex !== 0 &&
              <Box
                sx={{
                  m: 1,
                  width: '35px',
                  height: '35px',
                  // border: 1,
                  // borderColor: 'black',
                  borderRadius: '50%',
                  boxShadow: 3,
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <ArrowBackIcon 
                  // size={'lg'}
                  sx={{
                    m: 1,
                    color: 'black',
                    backgroundColor: arrowBackgroundColor(),
                    width: '35px',
                    height: '35px',
                    // border: 1,
                    // borderColor: 'black',
                    borderRadius: '50%',
                    // boxShadow: 3,
                    opacity: giveFeedbackTrue && arrowBackgroundColor() === 'mistyrose' ? 1 : giveFeedbackTrue ? .9 : .5,
                  }}
                />
              </Box>
            }
          </Box>

          {/* Loading */}
          {mediaIsLoading[`mediaItem${imageIndex + 1}`] 
            &&
            <Box
              sx={{
                width: '30%',
                height: tinderImageHeight(width),
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              Media is Loading...
            </Box>
          }

          {/* Forward */}
          <Box
            onClick={(e) => (viewTinderImageIndex < datingProfile.media.length - 1) && setViewTinderImageIndex(viewTinderImageIndex + 1)}
            disabled={viewTinderImageIndex >= datingProfile.media.length - 1}
            sx={{
              // backgroundColor: 'pink',
              width: '33%',
              height: tinderImageHeight(width) - 50,
              cursor: viewTinderImageIndex === datingProfile.media.length - 1 ? 'default' : 'pointer',
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end',
            }}
          >
            {viewTinderImageIndex !== datingProfile.media.length - 1 &&
              <Box
                sx={{
                  m: 1,
                  width: '35px',
                  height: '35px',
                  // border: 1,
                  // borderColor: 'black',
                  borderRadius: '50%',
                  boxShadow: 3,
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                <ArrowForwardIcon 
                  // size={'lg'}
                  sx={{
                    // m: 1,
                    color: 'black',
                    // backgroundColor: viewTinderImageIndex === 0 ? 'yellow' : 'white',
                    backgroundColor: arrowBackgroundColor(),
                    width: '35px',
                    height: '35px',
                    // border: 1,
                    // borderColor: 'black',
                    borderRadius: '50%',
                    // boxShadow: 0,
                    opacity: giveFeedbackTrue && arrowBackgroundColor() === 'mistyrose' ? 1 : giveFeedbackTrue || viewTinderImageIndex === 0 ? .9 : .5,
                  }}
                />
              </Box>
            }
          </Box>

        </Box>
      }

      {viewFeedbackTrue && datingProfile.mediaFeedback[imageIndex].feedback.length > 0 && datingProfile.mediaFeedback[imageIndex].verdict.length > 0 && 
        <Box
          sx={{
            width: tinderProfileImageWidth(width),
            borderRadius: `0px 0px ${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.mediaFeedback[imageIndex], 'media', datingProfile.type)}

        </Box>
      }
    </Box>
  )
}